import { Link } from 'react-router-dom';
import { platformStats, aboutFeatures, articles } from '@/mocks/data';
import Breadcrumb from '@/components/feature/Breadcrumb';

const aboutOrganizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'bb体育',
  url: 'https://www.bbtiyu.com/',
  description: 'bb体育是您信赖的专业体育平台，涵盖足球、篮球、网球等热门赛事投注与实时直播。',
  foundingDate: '2018',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    email: 'service@bbtiyu.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'CN',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'bb体育平台是否安全可靠？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'bb体育采用国际领先的SSL加密技术和银行级别安全防护体系，所有用户资金实行分离管理。平台运营多年，通过了ISO 27001信息安全管理体系认证，从未发生安全事故。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在bb体育注册账号？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '注册bb体育账号非常简单，只需访问bb体育官网，点击右上角"立即注册"按钮，填写基本信息并完成手机验证即可。注册即享888元专属礼包。',
      },
    },
    {
      '@type': 'Question',
      name: 'bb体育支持哪些充值方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'bb体育支持多种充值方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等，充值秒到账，提现最快5分钟到账。',
      },
    },
    {
      '@type': 'Question',
      name: 'bb体育的赔率有竞争力吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'bb体育拥有专业精算团队，实时跟踪全球各大博彩公司赔率变化，确保平台赔率在行业中始终保持领先水平。',
      },
    },
    {
      '@type': 'Question',
      name: 'bb体育有哪些赛事可以投注？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'bb体育覆盖全球50+体育联赛，包括足球、篮球、网球、电竞、棒球、拳击等，每天提供2000+场赛事供用户选择。',
      },
    },
  ],
};

export default function About() {
  return (
    <div className="pt-16">
      <script type="application/ld+json">{JSON.stringify(aboutOrganizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: '关于我们' },
        ]}
      />

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              关于<strong className="text-primary-500">bb体育</strong>
            </h1>
            <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
              bb体育成立于2018年，是亚洲领先的专业体育赛事投注与直播平台。我们致力于为全球体育爱好者提供安全、公平、便捷的在线投注体验。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14">
            {platformStats.map((stat) => (
              <div key={stat.label} className="bg-background-100 rounded-lg p-5 border border-background-200/70 text-center">
                <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className={`${stat.icon} text-lg text-primary-500`}></i>
                </div>
                <div className="text-xl md:text-2xl font-heading font-bold text-foreground-900">{stat.value}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 text-center mb-8">
            为什么选择bb体育
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {aboutFeatures.map((feature) => (
              <div key={feature.title} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-lg text-accent-600`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">{feature.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 text-center mb-8">
            品牌信誉
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
              <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                <i className="ri-shield-star-line text-primary-500"></i>
                安全保障
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>SSL 256位加密技术，保障所有数据传输安全</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>用户资金与运营资金完全分离，由第三方银行托管</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>ISO 27001信息安全管理体系认证</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>7×24小时安全监控，实时防御各类网络攻击</span>
                </li>
              </ul>
            </div>
            <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
              <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                <i className="ri-medal-line text-accent-500"></i>
                荣誉资质
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>2025年度亚洲最佳体育博彩平台</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>国际博彩协会（IGA）认证会员</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>连续三年获"最受用户信赖平台"称号</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5"></i>
                  <span>通过国际权威第三方机构公平性审计</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 text-center mb-8">
            常见问题
          </h2>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqSchema.mainEntity.map((item, index) => (
              <details key={index} className="bg-background-50 rounded-lg border border-background-200/70 group">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-800 group-open:text-primary-500">
                  {item.name}
                  <i className="ri-arrow-down-s-line transition-transform group-open:rotate-180 text-foreground-400"></i>
                </summary>
                <div className="px-5 pb-4 text-xs text-foreground-600 leading-relaxed">
                  {item.acceptedAnswer.text}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 text-center mb-8">
            联系我们
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
            <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
              <div className="w-11 h-11 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-lg text-primary-500"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">在线客服</h3>
              <p className="text-xs text-foreground-500 mb-3">7×24小时在线服务</p>
              <Link to="/about" className="text-xs text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap">
                立即咨询 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
              <div className="w-11 h-11 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-phone-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">客服热线</h3>
              <p className="text-xs text-foreground-500 mb-3">400-888-6666</p>
              <Link to="/about" className="text-xs text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap">
                拨打电话 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
              <div className="w-11 h-11 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-mail-line text-lg text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">邮件联系</h3>
              <p className="text-xs text-foreground-500 mb-3">service@bbtiyu.com</p>
              <Link to="/about" className="text-xs text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap">
                发送邮件 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            加入<strong className="text-primary-500">bb体育</strong>，开启您的竞技之旅
          </h2>
          <p className="text-sm text-foreground-600 mb-8">
            500万+用户的选择，安全、公平、便捷的专业体育投注平台
          </p>
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm inline-block"
          >
            立即注册
          </Link>
        </div>
      </section>
    </div>
  );
}